// extracted by mini-css-extract-plugin
export default {"root":"BasicCard_root__AAiSm"};